/**
 * Brazilian Portuguese (pt-BR) mappings for Welcome Message
 */

export const welcomeMessagePtBR = {
  // Welcome message text
  "Welcome to PickStar AI - Your Personalized Sports Research Assistant. Ask away!":
    "Bem-vindo ao PickStar AI - Seu Assistente de Pesquisa Esportiva Personalizado. Pergunte à vontade!"
};
